import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=4fc12ae6&scoped=true&"
import script from "./addressList.js?vue&type=script&lang=js&"
export * from "./addressList.js?vue&type=script&lang=js&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=4fc12ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc12ae6",
  null
  
)

export default component.exports